/**
 * @ignore
 */
export enum Role {
  USER = 'user',
  ROOT = 'root',
  CUSTOMER = 'customer',
  MANAGER = 'manager',
  CLIENT = 'client'
}
/**
 * @ignore
 */
export enum userType {
  BASIC = 'basic',
  PREMIUM = 'premium',
  SIMPLE = 'simple'
}